import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.per_page = 10;

        this.state = {
            transactions: props.transactions.data
                ? props.transactions.data.slice(0, this.per_page)
                : [],
            page: 1,
            pages: Math.ceil(props.transactions.count / this.per_page),
            type: 'all',
            total: props.transactions.count,
            start: 1,
            end: props.transactions.count >= this.per_page ? this.per_page : props.transactions.count,
        };

        props.getTransactions();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.transactions != this.state.transactions) {
            return true;
        }

        return false;
    }

    render({ user, type }, { transactions }) {
        if (transactions) {
            return (
                <transaction-history>
                    <transaction-history-header>
                        <row className='is-aligned-center is-wrap has-margin-20-bottom-mobile'>
                            <column className='is-6 is-12-mobile has-padding-25-bottom-mobile'>
                                CURRENT KARMA COIN BALANCE:
                                <br className='is-hidden-mobile' />
                                <span className='is-visible-mobile'> </span>
                                <span className='has-weight-500'>{user.kcs.total.toLocaleString()}</span>
                            </column>
                            <column className='is-6 is-12-mobile has-text-right-desktop has-text-right-tablet'>
                                VIEW BY TYPE:
                                <br className='is-hidden-mobile' />
                                <a
                                    href='#'
                                    onClick={(e) => this.setType(e, 'all')}
                                    className={type == 'all' ? 'active' : ''}
                                >
                                    All
                                </a>
                                <a
                                    href='#'
                                    onClick={(e) => this.setType(e, 'cash')}
                                    className={type == 'cash' ? 'active' : ''}
                                >
                                    Cash
                                </a>
                                <a
                                    href='#'
                                    onClick={(e) => this.setType(e, 'used')}
                                    className={type == 'used' ? 'active' : ''}
                                >
                                    KCs Used
                                </a>
                                <a
                                    href='#'
                                    onClick={(e) => this.setType(e, 'added')}
                                    className={type == 'added' ? 'active' : ''}
                                >
                                    KCs Added
                                </a>
                            </column>
                        </row>
                    </transaction-history-header>
                    {this.renderTransactions()}
                    {this.renderFooter()}
                </transaction-history>
            );
        }

        return (<transaction-history />);
    }

    /* eslint-disable max-len */
    renderTransactions = () => {
        if (this.state.transactions.length) {
            return (
                <transaction-history-list>
                    <row className='is-aligned-center'>
                        <column className='is-2 has-padding-10-left-desktop has-padding-10-left-tablet has-padding-5-left-mobile has-padding-5-right-mobile'>
                            DATE
                        </column>
                        <column className='is-7 is-4-mobile has-padding-5-left has-padding-5-right'>
                            DESCRIPTION
                        </column>
                        <column className='is-1 is-2-mobile has-text-center'>
                            CASH
                        </column>
                        <column className='is-1 is-2-mobile has-text-center'>
                            KCs +/-
                        </column>
                        <column className='is-1 is-2-mobile has-text-center has-padding-10-right'>
                            KCs BAL<span className='is-hidden-mobile'>ANCE</span>
                        </column>
                    </row>
                    {this.state.transactions.map(transaction => (
                        <row className='is-aligned-center'>
                            <column className='is-2 has-padding-10-left-desktop has-padding-10-left-tablet has-padding-5-left-mobile has-padding-5-right-mobile'>
                                {dayjs(transaction.transaction_date).format('M.D.YY h:mma')}
                            </column>
                            <column className='is-7 is-4-mobile has-padding-5-left has-padding-5-right'>
                                {this.renderDescription(transaction.description, transaction.product_url)}
                                {this.renderDiscount(transaction.discount)}
                            </column>
                            <column className='is-1 is-2-mobile has-text-center'>
                                {transaction.usd_amount ? `$${transaction.usd_amount.toLocaleString()}` : ''}
                            </column>
                            <column className='is-1 is-2-mobile has-text-center'>
                                {this.renderKCAmount(transaction.kc_amount)}
                            </column>
                            <column className='is-1 is-2-mobile has-text-center has-padding-10-right'>
                                {transaction.kc_balance.toLocaleString()}
                            </column>
                        </row>
                    ))}
                </transaction-history-list>
            );
        }

        return (
            <transaction-history-list>
                <h2 className='has-text-center'>No Transactions Found</h2>
                <p className='has-text-center'>If the problem persists, please <a href='/service'>contact support</a></p>
            </transaction-history-list>
        );
    }
    /* eslint-enable max-len */

    renderDescription = (description, url) => {
        if (url) {
            return (
                <div>
                    <a href={url.replace('https://www.tarot.com', '')}>{description}</a>
                </div>
            );
        }

        return (<div>{description}</div>);
    }

    renderDiscount = (discount) => {
        if (discount) {
            return (<small>{discount}% Discount</small>);
        }

        return null;
    }

    renderKCAmount = (kcs) => {
        if (kcs) {
            return kcs > 0
                ? (<span className='has-text-forest-green'>+{kcs.toLocaleString()}</span>)
                : (<span className='has-text-color-red'>{kcs.toLocaleString()}</span>);
        }

        return null;
    }

    renderFooter = () => {
        if (this.state.transactions.length) {
            const pgclass = 'is-6 is-12-mobile has-text-right-desktop has-text-right-tablet has-text-center-mobile';

            return (
                <transaction-history-footer>
                    <row className='is-wrap has-margin-20-top'>
                        <column className='is-6 is-12-mobile has-text-center-mobile has-padding-20-bottom-mobile'>
                            Displaying: {this.state.start} - {this.state.end + this.state.start - 1} of&nbsp;
                            {this.state.total} items
                        </column>
                        <column className={pgclass}>
                            Page: {this.renderPageLinks()}
                        </column>
                    </row>
                    <p className='has-text-center has-margin-20-top'>
                        Have questions? Contact <a href='mailto:support@tarot.com'>support@tarot.com</a>
                    </p>
                </transaction-history-footer>
            );
        }

        return null;
    }

    renderPageLinks = () => {
        let delta = 2;
        let range = [];
        let pages = [];
        let l;

        range.push(1);

        for (let i = this.state.page - delta; i <= this.state.page + delta; i++) {
            if (i < this.state.pages && i > 1) {
                range.push(i);
            }
        }

        if (this.state.pages != 1) {
            range.push(this.state.pages);
        }

        for (let i of range) {
            if (l) {
                if (i - l === 2) {
                    pages.push(l + 1);
                } else if (i - l !== 1) {
                    pages.push('...');
                }
            }

            pages.push(i);

            l = i;
        }

        return pages.map(page => {
            if (page == '...') {
                return (
                    <a href='#' onClick={(e) => e.preventDefault()} className='active'>
                        {page}
                    </a>
                );
            }

            return (
                <a
                    href='#'
                    onClick={(e) => this.setPage(e, page)}
                    className={page == this.state.page ? 'active' : ''}
                >
                    {page}
                </a>
            );
        });
    }

    setType = (e, type) => {
        e.preventDefault();

        if (type != this.state.type) {
            this.filter(type, 1);
        }
    }

    setPage = (e, page) => {
        e.preventDefault();

        if (page != this.state.page) {
            this.filter(this.state.type, page);
        }
    }

    filter = (type, page) => {
        const start = (page * this.per_page) - 9;
        let transactions = [];

        if (type == 'all') {
            transactions = this.props.transactions.data;
        } else if (type == 'cash') {
            transactions = _.reject(this.props.transactions.data, (transaction) => transaction.usd_amount == null);
        } else if (type == 'used') {
            transactions = _.reject(this.props.transactions.data, (transaction) =>
                transaction.kc_amount == null || transaction.kc_amount > 0
            );
        } else if (type == 'added') {
            transactions = _.reject(this.props.transactions.data, (transaction) =>
                transaction.kc_amount == null || transaction.kc_amount < 0
            );
        }

        const filtered = transactions.slice(start - 1, start + 9);

        const end = filtered.length >= this.per_page ? this.per_page : filtered.length;

        const pages = type == 'all'
            ? Math.ceil(this.props.transactions.count / this.per_page)
            : Math.ceil(transactions.length / this.per_page);

        this.setState({
            transactions: filtered,
            page: page,
            pages: pages,
            type: type,
            total: transactions.length,
            start: start,
            end: end,
        });
    }
}

const mapStateToProps = (state) => ({
    transactions: state.transactions,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    getTransactions: () => dispatch({ type: 'member:get-transactions' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);